import { render, staticRenderFns } from "./BacCountdown.vue?vue&type=template&id=48df8dc1&scoped=true&"
import script from "./BacCountdown.vue?vue&type=script&lang=ts&"
export * from "./BacCountdown.vue?vue&type=script&lang=ts&"
import style0 from "./BacCountdown.vue?vue&type=style&index=0&id=48df8dc1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48df8dc1",
  null
  
)

export default component.exports